<template>
<div class="chapter">
<div class="inner_page">
<p class="head2"><a id="page_vii"><img alt="image" src="images/half1.jpg"/> <span class="small">CONTENTS</span></a></p><a id="page_vii">
</a><p class="tocb"><a id="page_vii"></a><a href="#/list"><i>List of Illustrations ix</i></a></p>
<p class="toca"><a href="#/ack"><i>Acknowledgments xi</i></a></p>
<p class="toca"><a href="#/abb"><i>Abbreviations xv</i></a></p>
<p class="toca"><a href="#/map"><i>Maps xvi</i></a></p>
<p class="toc"><a href="#/int">Introduction <i>1</i></a></p>
<p class="toc1"><a href="#/ch01"><i>Chapter 1</i> <b>■</b> Absence <i>7</i></a></p>
<p class="toc1"><span href="#/ch02" title="Link target outside of Sample"><i>Chapter 2</i> <b>■</b> Empire <i>26</i></span></p>
<p class="toc1"><span href="#/ch03" title="Link target outside of Sample"><i>Chapter 3</i> <b>■</b> Hellenism <i>46</i></span></p>
<p class="toc1"><span href="#/ch04" title="Link target outside of Sample"><i>Chapter 4</i> <b>■</b> The Realms of Gold <i>68</i></span></p>
<p class="toc1"><span href="#/ch05" title="Link target outside of Sample"><i>Chapter 5</i> <b>■</b> The Very Model of Orthodoxy? <i>87</i></span></p>
<p class="toc"><span href="#/epi" title="Link target outside of Sample">Epilogue <i>112</i></span></p>
<p class="tocb"><span href="#/notes" title="Link target outside of Sample"><i>Notes 117</i></span></p>
<p class="toca"><span href="#/further" title="Link target outside of Sample"><i>Further Reading 149</i></span></p>
<p class="toca"><span href="#/author" title="Link target outside of Sample"><i>Author’s Note 155</i></span></p>
<p class="toca"><span href="#/index" title="Link target outside of Sample"><i>Index 157</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?028538d2